import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  Stack,
  IconButton,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router";
import { useAuth } from "../context/AuthContext";
import useAuthenticatedBootstrap from "../hook/useAuthenticatedBootstrap";
import { useSelector } from "react-redux";
import MainViewClient from "../routes/MainViewClient";

// Icônes
import DashboardIcon from "@mui/icons-material/Dashboard";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import SecurityIcon from "@mui/icons-material/Security";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";

export default function ClientLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { data: organizations = [] } = useSelector(
    (state) => state.organizations.organizations
  );

  useAuthenticatedBootstrap();

  const menuItems = [
    {
      label: "Tableau de bord",
      path: "/app/home",
      icon: <DashboardIcon />,
    },
    {
      label: "O365",
      path: "/app/o365",
      icon: <MailOutlineIcon />,
      service: organizations[0]?.o365Licenses,
    },
    {
      label: "Antivirus ESET",
      path: "/app/eset",
      icon: <SecurityIcon />,
      service: organizations[0]?.esetLicenses,
    },
    {
      label: "Personnel",
      path: "/app/staff",
      icon: <PeopleAltIcon />,
    },
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      {/* Top Navbar */}
      <AppBar
        position="fixed"
        color="inherit"
        sx={{
          bgcolor: "background.paper",
          color: "text.primary",
          borderBottom: "1px solid",
          borderColor: "divider",
          boxShadow: "none",
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between", flexWrap: "wrap", gap: 2 }}>
          {/* Logo + Nom */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Box
              component="img"
              sx={{ height: 40 }}
              alt="Omnibox Logo"
              src="/img/omnibox.png"
            />
          </Box>

          {/* Onglets */}
          <Stack
            direction="row"
            spacing={1}
            flexWrap="wrap"
            justifyContent="center"
            alignItems="center"
          >
            {menuItems.map((item) => {
              const shouldDisplay =
                item.service === undefined ||
                (Array.isArray(item.service)
                  ? item.service.length > 0
                  : !!item.service);

              if (!shouldDisplay) return null;

              const isSelected = location.pathname.startsWith(item.path);

              return (
                <Button
                  key={item.path}
                  variant={isSelected ? "contained" : "text"}
                  startIcon={item.icon}
                  onClick={() => navigate(item.path)}
                  sx={{
                    color: isSelected ? "primary.contrastText" : "text.primary",
                    bgcolor: isSelected ? "primary.main" : "transparent",
                    borderRadius: 2,
                    "&:hover": {
                      bgcolor: isSelected ? "primary.dark" : "action.hover",
                    },
                  }}
                >
                  {item.label}
                </Button>
              );
            })}
          </Stack>

          {/* Déconnexion */}
          <Button color="inherit" onClick={logout}>
            Déconnexion
          </Button>
        </Toolbar>
      </AppBar>

      {/* Contenu principal */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          mt: 9,
          px: { xs: 2, md: 4 },
          py: 3,
          overflowY: "auto",
          backgroundColor: "#f7f8fa",
        }}
      >
        <MainViewClient />
      </Box>
    </Box>
  );
}
